<template>
  <div id="app">
    <div id="content" class="addedit-person">
      <!-- HEADER -->
      <Header
        :page="'participant_campus_edit'"
        :title_one="'participant'"
        :action_one="'update'"
        :action_two="'cancel'"
        :banner_docsok_msg="doc_ok"
        @update="validate()"
      ></Header>

      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <div class="box">
            <h6 class="form-subtitle">
              {{ $t("titles.medicaments_allergies_and_intolerances") }}
            </h6>

            <v-flex xs12 v-if="event.type_id == 4">
              <div class="item">
                <label
                  >{{ $t("params.auth_antitermic") }}
                  <span class="obligatory">*</span>
                </label>
                <v-radio-group v-model="input.antitermic" row>
                  <v-radio value="1">
                    <template v-slot:label>
                      <span :class="{ obligatory: error.antitermic }">{{
                        $t("params.authorize")
                      }}</span>
                    </template>
                  </v-radio>
                  <v-radio value="0">
                    <template v-slot:label>
                      <span :class="{ obligatory: error.antitermic }">{{
                        $t("params.no_authorize")
                      }}</span>
                    </template>
                  </v-radio>
                </v-radio-group>
              </div>
            </v-flex>

            <v-flex xs12>
              <div class="item expanded">
                <label>{{ $t("params.allergies_intolerances") }}</label>
                <v-layout
                  row
                  wrap
                  class="box mobile-box"
                  style="margin-bottom: -10px"
                  v-for="(item, index) in input.allergies_intolerances"
                  :key="index"
                >
                  <v-flex xs10 style="margin-bottom: 0px">
                    <input
                      type="text"
                      v-model="item.name"
                      autocomplete="new-text"
                    />
                  </v-flex>
                  <v-flex
                    xs2
                    md2
                    lg2
                    xl2
                    class="icon"
                    style="padding-top: 10px"
                  >
                    <v-icon
                      v-if="input.allergies_intolerances.length > 1"
                      @click="input.allergies_intolerances.splice(index, 1)"
                      >remove</v-icon
                    >
                    <v-icon
                      v-if="
                        index == input.allergies_intolerances.length - 1 &&
                        input.allergies_intolerances.length < 7
                      "
                      @click="input.allergies_intolerances.push({ name: '' })"
                      >add</v-icon
                    >
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>

            <v-flex xs12>
              <div class="item expanded">
                <label>{{ $t("params.allergic_reactions") }}</label>
                <v-layout
                  row
                  wrap
                  class="box mobile-box"
                  style="margin-bottom: -10px"
                  v-for="(item, index) in input.allergic_reactions"
                  :key="index"
                >
                  <v-flex xs10 style="margin-bottom: 0px">
                    <input
                      type="text"
                      v-model="item.name"
                      autocomplete="new-text"
                    />
                  </v-flex>
                  <v-flex
                    xs2
                    md2
                    lg2
                    xl2
                    class="icon"
                    style="padding-top: 10px"
                  >
                    <v-icon
                      v-if="input.allergic_reactions.length > 1"
                      @click="input.allergic_reactions.splice(index, 1)"
                      >remove</v-icon
                    >
                    <v-icon
                      v-if="
                        index == input.allergic_reactions.length - 1 &&
                        input.allergic_reactions.length < 7
                      "
                      @click="input.allergic_reactions.push({ name: '' })"
                      >add</v-icon
                    >
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>

            <v-flex xs12>
              <div class="item expanded">
                <label>{{ $t("params.what_to_do_allergy") }}</label>
                <v-textarea
                  auto-grow
                  rows="1"
                  :value="input.what_to_do"
                  @change="(v) => (input.what_to_do = v)"
                ></v-textarea>
              </div>
            </v-flex>

            <v-flex xs12>
              <div class="item expanded">
                <label>{{ $t("params.medicamento") }}</label>
                <v-layout
                  row
                  wrap
                  class="box mobile-box"
                  style="margin-bottom: -10px"
                  v-for="(item, index) in input.medicaments"
                  :key="index"
                >
                  <v-flex xs12 md6 style="margin-bottom: 0px">
                    <input
                      type="text"
                      v-model="item.name"
                      autocomplete="new-text"
                      :placeholder="$t('params.name')"
                    />
                  </v-flex>
                  <v-flex xs6 md3 style="margin-bottom: 0px">
                    <v-menu
                      v-model="dialog_start_date[index]"
                      autocomplete="new-text"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                      :class="error.medicaments.start_date ? 'error' : ''"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="item.parsedStartDate"
                        :placeholder="'DD/MM/YYYY'"
                        prepend-icon="event"
                        readonly
                      />
                      <v-date-picker
                        v-model="item.start_date"
                        @input="
                          (dialog_start_date[index] = false),
                            formatStartDate(item)
                        "
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs6 md3 style="margin-bottom: 0px">
                    <v-menu
                      v-model="dialog_end_date[index]"
                      autocomplete="new-text"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                      :class="error.medicaments.end_date ? 'error' : ''"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="item.parsedEndDate"
                        :placeholder="'DD/MM/YYYY'"
                        prepend-icon="event"
                        readonly
                      />
                      <v-date-picker
                        v-model="item.end_date"
                        @input="
                          (dialog_end_date[index] = false), formatEndDate(item)
                        "
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs4 md4 style="margin-bottom: 0px">
                    <input
                      type="text"
                      v-model="item.dosis"
                      autocomplete="new-text"
                      :placeholder="$t('params.dosis')"
                    />
                  </v-flex>
                  <v-flex xs4 md4 style="margin-bottom: 0px">
                    <input
                      type="text"
                      v-model="item.hours"
                      autocomplete="new-text"
                      :placeholder="$t('params.hours')"
                    />
                  </v-flex>
                  <v-flex
                    xs2
                    md2
                    lg2
                    xl2
                    class="icon"
                    style="padding-top: 10px"
                  >
                    <v-icon
                      v-if="input.medicaments.length > 1"
                      @click="
                        input.medicaments.splice(index, 1);
                        dialog_start_date.splice(index, 1);
                        dialog_end_date.splice(index, 1);
                      "
                      >remove</v-icon
                    >
                    <v-icon
                      v-if="
                        index == input.medicaments.length - 1 &&
                        input.medicaments.length < 7
                      "
                      @click="
                        input.medicaments.push({
                          name: '',
                          start_date: '',
                          end_date: '',
                          dosis: '',
                          hours: '',
                        });
                        dialog_start_date.push(false);
                        dialog_end_date.push(false);
                      "
                      >add</v-icon
                    >
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>

            <h6 class="form-subtitle">
              {{ $t("titles.external") }}
            </h6>

            <v-flex xs12>
              <div class="item">
                <label
                  >{{ $t("params.participant_goes_alone") }}
                  <span class="obligatory">*</span>
                </label>
                <v-radio-group v-model="input.alone_to_home" row>
                  <v-radio value="1">
                    <template v-slot:label>
                      <span :class="{ obligatory: error.antitermic }">{{
                        $t("bool.si")
                      }}</span>
                    </template>
                  </v-radio>
                  <v-radio value="0">
                    <template v-slot:label>
                      <span :class="{ obligatory: error.antitermic }">{{
                        $t("bool.no")
                      }}</span>
                    </template>
                  </v-radio>
                </v-radio-group>
              </div>
            </v-flex>

            <template v-if="input.alone_to_home == '0'">
              <div class="item expanded">
                <label>{{ $t("params.people_authorize") }} <span class="obligatory">*</span></label>
                <span class="error" v-if="error.alone_to_home">
                  {{ $t("required_field") }}
                </span>

                <v-flex xs12 v-for="(item, index) in input.externals">
                  <v-layout
                    row
                    wrap
                    class="box mobile-box"
                    style="margin-bottom: -10px"
                  >
                    <v-flex xs6 md6 style="margin-bottom: 0px">
                      <input
                        type="text"
                        v-model="item.name"
                        autocomplete="new-text"
                        :placeholder="$t('params.name')"
                      />
                    </v-flex>
                    <v-flex xs6 md6 style="margin-bottom: 0px">
                      <input
                        type="text"
                        v-model="item.surname"
                        autocomplete="new-text"
                        :placeholder="$t('params.surname')"
                      />
                    </v-flex>
                    <v-flex xs4 md4 style="margin-bottom: 0px">
                      <input
                        type="text"
                        v-model="item.dni"
                        autocomplete="new-text"
                        :placeholder="$t('params.dni')"
                      />
                    </v-flex>
                    <v-flex xs4 md4 style="margin-bottom: 0px">
                      <input
                        type="text"
                        v-model="item.parentiu"
                        autocomplete="new-text"
                        :placeholder="$t('params.range_family')"
                      />
                    </v-flex>
                    <v-flex
                      xs2
                      md2
                      lg2
                      xl2
                      class="icon"
                      style="padding-top: 10px"
                    >
                      <v-icon
                        v-if="input.externals.length > 1"
                        @click="input.externals.splice(index, 1)"
                        >remove</v-icon
                      >
                      <v-icon
                        v-if="
                          index == input.externals.length - 1 &&
                          input.externals.length < 7
                        "
                        @click="
                          input.externals.push({
                            name: '',
                            dni: '',
                          })
                        "
                        >add</v-icon
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>
              </div>
            </template>

            <ErrorPopup
              @close="closePopup()"
              @input="closePopup()"
              :dialog="dialog"
            ></ErrorPopup>

            <div class="actions">
              <div class="btn" id="cancel" @click="campus_home()">
                {{ $t("cancel") }}
              </div>
              <div class="btn" id="addedit" @click="validate()">
                {{ $t("update") }}
              </div>
            </div>
          </div>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
import i18n from "@/i18n";
import ErrorPopup from "@/components/ui/ErrorPopup.vue";
import Header from "@/components/layout/Header";

export default {
  name: "CampusPersonEdit",
  components: {
    ErrorPopup,
    Header,
  },
  data() {
    return {
      input: {
        antitermic: "1",
        allergies_intolerances: [{ name: "" }],
        allergic_reactions: [{ name: "" }],
        what_to_do: "",
        medicaments: [
          {
            name: "",
            start_date: "",
            end_date: "",
            dosis: "",
            hours: "",
            p: 0,
          },
        ],
        alone_to_home: "1",
        externals: [{ name: "", dni: "" }],
      },
      alergies: {},
      error: {
        medicaments: {
          start_date: false,
          end_date: false,
        },
      },
      is_virtual: false,
      dialog: false,
      dialog_start_date: [false],
      dialog_end_date: [false],
      doc_ok: true
    };
  },
  computed: {
    user() {
      return this.$store.getters["user/getUser"];
    },

    event() {
      return this.$store.getters.getCurrentEvent();
    },
  },
  created() {
    // save campus
    this.$store.commit("setCampus", true);

    // get player information
    var self = this;

    this.$store
      .dispatch("person/loadPersonCampus", {
        campus_id: this.user.event_id,
        participant_id: this.user.participant_id,
      })
      .then(function () {
        // save player information
        let person = self.$store.getters["person/getPerson"];
        // save information

        self.input.b_medicamento = person.b_medicamento;
        self.input.medicamento = person.medicamento;
        self.input.antitermic = person.antitermic;
        self.input.alone_to_home = person.alone_home;
        if (person.allergies) {
          var allergies = JSON.parse(person.allergies);
          self.input.what_to_do = allergies.wd ? allergies.wd : "";
          if (allergies.a.length > 0) {
            self.input.allergies_intolerances = [];
            allergies.a.forEach((allergy) => {
              self.input.allergies_intolerances.push({ name: allergy });
            });
          }
          if (allergies.r.length > 0) {
            self.input.allergic_reactions = [];
            allergies.r.forEach((allergy) => {
              self.input.allergic_reactions.push({ name: allergy });
            });
          }
        }
        if (person.externals)
          self.input.externals = JSON.parse(person.externals);
        if (person.medicaments)
          var medicaments = JSON.parse(person.medicaments);
        if (medicaments.length > 0) {
          self.input.medicaments = medicaments;
        }

        if (
          (!person.antithermal && [4, 5].includes(self.event.type_id)) ||
          !person.medicines ||
          !person.externals ||
          !person.image_right
        ) {
          self.doc_ok = false
        }

        // get countries and alergies
        self.$store
          .dispatch("getCampusInfo", { event_id: self.user.event_id })
          .then(function () {
            self.alergies = self.$store.getters["getAlergy"];

            // looop for each campus
            for (let i in self.input.campus) {
              // get campus
              let campus = self.campus_types[self.input.campus[i]];

              if (campus.type == "campus.pga_virtual") self.is_virtual = true;
            }
          });
      });
  },
  methods: {
    refresh() {
      this.$forceUpdate();
    },
    validate() {
      // validate
      let validate = true;

      if (isEmpty(this.input.medicamento) && !this.is_virtual)
        this.input.medicamento = "";

      if (parseInt(this.input.alone_to_home) == 0 && this.input.externals.length == 0) {
        this.error.alone_to_home = true;
        validate = false;
      } else if (parseInt(this.input.alone_to_home) == 0){
        let firstExternal = this.input.externals.find(item => item.name != "" && item.surname != "" && item.dni != "" && item.parentiu != "");
        if (firstExternal) {
          this.error.alone_to_home = false;
        } else {
          this.error.alone_to_home = true;
          validate = false;
        }
      } else {
        this.error.alone_to_home = false;
        validate = true;
      }

      if (validate) {
        var self = this;
        var params = {
          antitermic: this.input.antitermic,
          alone_home: this.input.alone_to_home,
          allergies: { a: [], r: [], wd: this.input.what_to_do },
          medicaments: [],
          external: this.input.externals,
        };

        this.input.allergies_intolerances.forEach((ai) => {
          if (ai.name != "") {
            params.allergies.a.push(ai.name);
          }
        });
        this.input.allergic_reactions.forEach((ar) => {
          if (ar.name != "") {
            params.allergies.r.push(ar.name);
          }
        });
        this.input.medicaments.forEach((ar) => {
          if (ar.name != "") {
            params.medicaments.push(ar);
          }
        });

        params.allergies = JSON.stringify(params.allergies);
        params.medicaments = JSON.stringify(params.medicaments);
        params.external = JSON.stringify(params.external);

        // update player
        var id = self.$route.params.person_id;
        self.$store
          .dispatch("person/campusUpdateInfoPlayer", {
            campus_id: self.user.event_id,
            participant_id: self.user.participant_id,
            input: params,
          })
          .then(function () {
            self.campus_home();
          });
      } else {
        this.dialog = true;
      }
    },

    closePopup() {
      this.dialog = false;
    },

    campus_home() {
      this.$router
        .push({
          name: "campus_home",
          params: { campus_id: this.user.event_id },
        })
        .catch((err) => {});
    },

    removeAlergy(item) {
      let index = this.input.alergy.indexOf(item.id);
      if (index >= 0) {
        let aux = JSON.parse(JSON.stringify(this.input.alergy));
        aux.splice(index, 1);
        this.input.alergy = aux;
      }
    },

    formatStartDate(item) {
      item.parsedStartDate = moment(item.start_date).format("DD/MM/YYYY");
    },

    formatEndDate(item) {
      item.parsedEndDate = moment(item.end_date).format("DD/MM/YYYY");
    },
  },
  watch: {},
  mounted() {},
};
</script>

<style lang="scss">
#content.addedit-person {
  .box {
    width: 100% !important;
    max-width: 900px;
    margin: 0 auto;
    margin-top: 25px !important;

    .message.input-error {
      color: $warning-color;
    }

    .upper {
      text-transform: uppercase;
      &::placeholder {
        text-transform: none;
      }
    }

    /* Alergy */
    .v-menu__content {
      margin-top: 43px;
    }

    .item {
      width: 50%;
      margin: 0px 0px 20px 0px;
      padding: 0 15px;
      display: inline-block;

      &.expanded {
        width: 100% !important;
      }

      label {
        font-size: 14px;
        padding: 0;
        margin: 2px 0;
        display: block;
        font-weight: bold;

        a {
          text-decoration: underline;
          cursor: pointer;
          font-weight: bold;
        }

        span.info {
          font-weight: bold;
          color: #fc8926 !important;
        }
      }

      .v-radio {
        margin-right: 15px;
      }

      .v-input {
        margin-top: 0;
      }
      .v-input__slot {
        margin-bottom: 0;
      }

      input,
      select,
      .v-autocomplete .v-input__slot,
      .v-select {
        width: 100%;
        padding: 10px;
        // margin-bottom: 5px;
        border: 1px solid $secondary-color;
        outline: none;
        font-size: 16px;
        border-radius: 3px;
        color: $dark-color;

        &::placeholder {
          color: $dark-color;
          opacity: 0.5;
        }
      }

      // input:disabled, select:disabled, .v-input--is-disabled {
      //   @include opacity(0.3);
      // }

      .v-autocomplete {
        margin-top: 0;
        padding-top: 0;

        .v-input__control {
          .v-input__slot {
            margin: 0;
            padding: 4px;

            &:after,
            &:before {
              content: "";
              border: none !important;
            }
          }
          .v-select__slot {
            border: none;

            input {
              border: none;
              margin: 0;
            }
          }
        }
      }

      .obligatory {
        color: $alert-color;
        font-weight: bold;
        font-size: 16px;

        &.error {
          display: block;
        }
      }

      .input-error {
        border: 1px solid;
        border-color: $alert-color !important;
        &::placeholder {
          color: $alert-color !important;
          opacity: 0.5;
        }
        .v-input__slot {
          border-color: $alert-color;
        }
      }

      .readonly {
        cursor: not-allowed;
      }

      input:disabled,
      select:disabled {
        background-color: #ddd;
        cursor: not-allowed;
        @include opacity(0.5);
      }
    }

    .error {
      border-color: red !important;

      &::placeholder {
        color: $alert-color !important;
        opacity: 1;
      }

      .v-input__slot {
        border-color: $alert-color;
      }

      .vti__input {
        border-color: red !important;
      }
    }

    .date-picker.error {
      input {
        border: 1px solid red;
      }
    }

    #medicamento,
    #alergy {
      input[type="text"],
      select,
      .v-select {
        display: inline-block;
        width: calc(100% - 40px);
      }

      .checkbox {
        display: inline-block;
        width: 40px;
        height: 40px;
      }
    }
    #alergy {
      ::before {
        display: none;
      }

      .v-select .v-input__slot {
        padding: 6px;
        height: 42px;
      }

      .v-chip .v-chip__content {
        height: 26px;
      }

      .v-text-field__details {
        display: none !important;
      }

      .v-input {
        width: 100% !important;
      }

      input {
        border: none;
      }

      .v-input__control {
        padding: 0;
      }

      .v-input__slot {
        height: auto !important;
      }
    }

    #birthday {
      .error {
        input {
          border: 1px solid red;
        }
      }
    }

    #country,
    #nacionality {
      .v-select {
        padding: 0;
      }
      .v-autocomplete {
        border: none;
      }
    }

    select {
      background-image: url("/img/sort-down.svg");
      background-size: 10px;
      background-position: right 10px center;
      background-repeat: no-repeat;
    }

    select option {
      font-size: 14pt;
    }

    button.btn {
      max-width: 300px;
      width: 100%;
      padding: 15px;
      outline: none;
      border: none;
      cursor: pointer;
      font-size: 12pt;
      font-family: Speedee-Bold;
      margin-top: 25px;
      border-radius: 3px;
      border: 1px solid $secondary-color;
      text-transform: uppercase;
      transition: all 0.5s;
      background: #222;
      color: $secondary-color;

      &:hover {
        background: $main-color;
      }
    }

    .form-subtitle {
      margin-top: 36px;
      background: #eee;
      padding: 7px;

      &:first-of-type {
        margin-top: 12px;
      }
    }
  }
}

@include media("<=desktop") {
  #content.addedit-person {
    .box {
      width: 100%;
      padding: 0;
      margin: 0;

      .item {
        width: 100%;
        display: block;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.actions {
  padding: 25px;
  margin: 0 auto;
  margin-bottom: 25px;
  text-align: center;

  .btn {
    width: calc(50% - 20px);
    margin: 0 10px;
    display: inline-block;
    min-width: 40px;
    padding: 0 35px;
    outline: none;
    border: none;
    cursor: pointer;
    text-align: center;
    font-size: 16px;
    border-radius: 3px;
    -webkit-transition: all 0.5s;
    transition: all 0.5s;
    background-color: #172654;
    color: #fff;
    height: 40px;
    line-height: 40px;
    text-transform: uppercase;
    background-color: #fc8926;
    font-family: AvantGarde-Bold;
    max-width: 300px;
    transition: background-color 0.5s ease;

    &#addedit {
      border: 1px solid #fc8926;

      &:hover {
        background-color: #e78026;
        border-color: #e78026;
      }
    }

    &#cancel {
      background-color: transparent;
      color: #c55c00;
      border: 1px solid #fc8926;

      &:hover {
        background-color: #fc8a2623 !important;
      }
    }
  }
}

@include media("<=desktop") {
  .actions {
    padding: 25px 0px;

    .btn {
      padding: 0 15px;
    }
  }
}
</style>
